import Header from "./components/Header";
import Carousel from "./components/Carousel";
import CarouselMain from "./components/CarouselMain";
import Call from "./components/Call";
import PorqueElegirnos from "./components/PorqueElegirnos";
import Services from "./components/Services";
import Footer from "./components/Footer";
import ImgStart from "./components/ImgStart";
import Promo from "./components/Promo"
import Formulario from "./components/Formulario"
import FormStart from "./components/FormStart"
import CasosExito from "./components/CasosExito";
import ChatBotPromo from "./components/ChatBotPromo";
import Bot from "./components/Bot";

function App() {
  return (
    <div>
      <Header />
      <Promo/>
      <CarouselMain />
      <FormStart/>
      <ImgStart />
      <Carousel />
      <Call />
      <PorqueElegirnos />
      <Services />
      <CasosExito/>
      <Formulario />    
      <ChatBotPromo />    
      <Footer />
      <Bot />
    </div>
  );
}

export default App;
